import {
  LOGIN_REQUEST,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
} from '../constants/actionTypes'

const initialState = {
  isFetching: false,
  isAuthenticated: !!localStorage.getItem('reggora_auth_token'),
}

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        errorMessage: '',
      }
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
      }
    case LOGIN_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message,
        statusCode: action.statusCode,
      }
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
      }
    default:
      return state
  }
}
